import { useAuth } from "@/hooks/use-auth";

/**
 * Client mirror of the two employee-base capabilities defined in
 * `server/lib/authorization.ts`:
 *
 * - `employees` ("Colaboradores") — the full record: personal data, salary,
 *   compensation history, create/delete, spreadsheet import.
 * - `employees_manager` ("Operador de Colaboradores") — the whole base, but
 *   only status, end date, direct manager, job title, department, COMP
 *   discipline and level are editable (`EMPLOYEE_OPERATOR_EDITABLE_FIELDS`), plus the Slack sync.
 *
 * The gates here only keep the UI from showing empty sensitive columns and
 * from firing requests that would 403 (a 403 raises the global "Sem
 * permissão" toast). The server stays the source of truth: it projects the
 * record for an operator and refuses writes outside the operator fields.
 */
export function useEmployeeAccess() {
  const { hasPermission } = useAuth();
  const canManageEmployees = hasPermission("employees");

  return {
    /** Full record, compensation, create/delete, import. */
    canManageEmployees,
    /** Can open /employees for the whole base and run the Slack sync. */
    canMaintainEmployeeBase: canManageEmployees || hasPermission("employees_manager"),
    /** Sees the operator projection — hide sensitive columns and tabs. */
    isEmployeeOperator: !canManageEmployees && hasPermission("employees_manager"),
  };
}
